export default __webpack_public_path__ + "static/media/BEETS.460474eb.png";